function empty() {
  return [];
}

export default function(selector) {
  return selector == null ? empty : function() {
    return this.querySelectorAll(selector);
  };
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/d3/node_modules/d3-selection/src/selectorAll.js
// module id = 288
// module chunks = 0